import styles from './Token.module.scss';
import React, { useState, useRef } from 'react';
import { format } from 'date-fns'
import {
  Call as CallIcon,
  HowToRegOutlined,
  ExitToApp as ExitToAppIcon,
  MoreVert as MoreVertIcon,
  NotificationsOff as NotificationsOffIcon,
  Notifications,
  NotificationsActive as NotificationsActiveIcon,
  VisibilityOffTwoTone
} from '@mui/icons-material';

import { Menu, MenuItem, IconButton } from '@mui/material';
import { formatTokenNumber } from '../../../../utils/textOperations'
import { StandardButton } from '../../../common/Button';
import ModalConfirm from '../../../common/ModalConfirm/ModalConfirm';
import { Tooltip } from '@mui/material';

const { cancelGuest, dbQueueWithCurDateRef, moveNoShowUpGuest, updateToken } = require('../../../../api/queue')

const iconSize = 'medium';
const notifyStatus = false;

const NotifyIcon = ({ tokenStatus, notifyStatus }) => {
  return <Notifications fontSize={iconSize} className={styles['token-icon-on-info-box']} />
};


const ActionMenu = ({ token, onCheckIn, onNoShowUp, onCancel , onNotify}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  

  const handle3DotClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onCheckInClick = async () => {
    await onCheckIn(token)
    handleClose()
  };

  const onNoShowUpClick = async() => {
    await onNoShowUp(token)
    handleClose()
  };

  const onCancelClick = async () => {
    try {
      await onCancel(token)
      handleClose();

    } catch (error) {
      console.error("\tError by: ", error.message)
    }
    finally {
      handleClose();
    }
  };

  const onCallClick = () => {
    handleClose()
    window.open(`tel:+${token.phone}`, '_self');
  };

  const onNotifyClick = async () => {
    try {
      await onNotify(token)
      handleClose();
    }
    catch (error) {
      console.error("Error in sending notification: ", error.message)
    }
    finally{
      handleClose()

    }
  };
  const deleteGuestRef = useRef();

  const openModal = () => {
    if (deleteGuestRef.current) {
      deleteGuestRef.current.openModal({
        id: token.queueId,
        text: `Are you sure you want to remove ${token.name ? token.name : "this guest"} ?`,
      });
    } else {
      console.error('deleteGuestRef.current is null');
    }
  };


  return (
    <>
    <ModalConfirm 
      ref={deleteGuestRef}
      onConfirm={onCancelClick}
      title="Delete Guest">
    </ModalConfirm>
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handle3DotClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}>
        <MenuItem onClick={onCallClick} >
          <CallIcon className={styles['token-icon']} fontSize={iconSize} />
          &nbsp;Call
        </MenuItem>
        <div className={styles['check-in-notify-in-menu']}>
          <MenuItem onClick={onNotifyClick} >
            <NotifyIcon tokenStatus={token.status} notifyStatus={notifyStatus} />
            &nbsp;Notify
          </MenuItem>
          <MenuItem onClick={onCheckInClick} >
            < HowToRegOutlined className={styles['token-icon']} fontSize={iconSize} />
            &nbsp;Check In
          </MenuItem>
        </div>
        <MenuItem onClick={onNoShowUpClick} >
          < VisibilityOffTwoTone className={styles['token-icon']} fontSize={iconSize} />
          &nbsp;No Show-up
        </MenuItem>

        <MenuItem onClick={openModal} >
          < ExitToAppIcon className={styles['token-icon']} fontSize={iconSize} />
          &nbsp;Remove Guest
        </MenuItem>

      </Menu>

    </div>
    </>
  );
}

function Token({ token, onNoShowUp, onCheckIn, onCancel, onNotify }) {
  return (
      <section className={styles.token}>
        {/* <div className={`${styles['token-position']}`} title='Current Position'>
          <p>{token.position}</p>
        </div> */}
        <Tooltip title="Current Position" arrow placement="top">
          <div className={styles['token-position']}>
            <p>{token.position}</p>
          </div>
        </Tooltip>
        {/* <div className={styles['token-number']} title='ID'>
          <p>{formatTokenNumber(token.number)}</p>
        </div> */}
        <Tooltip title="ID" arrow placement="top">
          <div className={styles['token-number']}>
            <p>{formatTokenNumber(token.number)}</p>
          </div>
        </Tooltip>
        <div className={styles['token-details']}>
          <div className={styles['token-name-time']} data-cypress-name={`added-guest-${token.name}`}>
            <p>{format(token.startedTime, 'yyyy-MM-dd HH:mm:ss')}</p>
            <p>{token.name}</p>
          </div>
          <div className={styles['button-on-info-box']}>
            <StandardButton onClick={() => onNotify(token)} >
              <NotifyIcon tokenStatus={token.status} notifyStatus={notifyStatus} />
              &nbsp;Notify
            </StandardButton>
            <StandardButton onClick={() => onCheckIn(token)}>
            < HowToRegOutlined className={styles['token-icon-on-info-box']} fontSize={iconSize} />
              &nbsp;Check In
            </StandardButton>
          </div>           
          <div className={styles['token-operations']}>
            <div className={styles['token-icon-set']}>
              <ActionMenu token={token} onNoShowUp={onNoShowUp} onCheckIn={onCheckIn} onCancel={onCancel} onNotify={onNotify} />
            </div>
          </div>
        </div>
      </section>
  );
}

export default Token;
